import React from 'react'
import { Box, Grid, IconButton, Typography } from '@material-ui/core'
import { itemBoxStyle } from './file-upload-field.style'
import { RemoveSvg } from '~/components/icons'
import { convertFileNameEllipsis, convertFileSize } from '~/common/helpers'
import { FIELD_MODE } from '~/common/constants'

function UploadListImage({ mode, onClick, item, onClick1, handleErrorImage, hideDelete = false, onRefreshFileUrl }) {
	const isRenderEdit = mode === FIELD_MODE.edit || (mode === FIELD_MODE.viewDisable && item.hasOwnProperty('signedBlobId'))

	const handleError = () => {
		try {
			handleErrorImage(item?.blobId)
		} catch (error) {
			console.error(error)
		}
	}

	const handleClick = async (e) => {
		e.preventDefault()

		if (onRefreshFileUrl) {
			const updatedFile = await onRefreshFileUrl(item)
			if (updatedFile) {
				onClick(updatedFile)
				return
			}
		}

		onClick(item)
	}

	return (
		<Grid item xs={12} sm={6}>
			<Box css={itemBoxStyle} onClick={handleClick}>
				<Box
					style={{
						borderRadius: '8px',
					}}
					className="preview-image"
				>
					<img onError={handleError} style={{}} src={item?.imageUrls?.s_500x500 || item?.src || item?.fileUrl} alt={item.filename} />
				</Box>
				<Box className="file">
					<Typography className="file__name">{convertFileNameEllipsis(item?.filename)}</Typography>
					<Typography className="file__size">{convertFileSize(item?.byteSize)}</Typography>
				</Box>
				{isRenderEdit && !hideDelete && (
					<IconButton className="removeIcon" size="small" onClick={onClick1}>
						<RemoveSvg />
					</IconButton>
				)}
			</Box>
		</Grid>
	)
}

export default UploadListImage
